import * as A from '@/store/mutation-types';
import { Store } from 'vuex';

export class ActionService {
  constructor(public store: Store<any>) {}

  public setDialogState(state: boolean) {
    return new Promise((resolve, reject) => {
      this.store.commit(A.SET_DIALOG_STATE, state);
      resolve();
    });
  }
}
